import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";



export const CommitteeBatchApprovalConfig={
    columns: [
        {
            name: "Batch Number",
            fieldName: "batchNumber",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Set Date",
            fieldName: "sentDate",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY',
            }
        },
        {
            name: "Link Close Date",
            fieldName: "linkCloseDate",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY',
            }
        },
        {
            name: "Course Provider",
            fieldName: "numberOfCourseProvider",
            colType: GridColumnType.Text,
        },
        {
            name: "Event",
            fieldName: "numberOfEvent",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: false,
                allowDelete: false
            },
            customAction: [
                {
                    name: "View",
                    // onViewAction: (data) => {
                    //     alert("called permissions");
                    // },
                },
            ],
        },

    ],
};